import { IModulePermissionType } from 'types'

/**
 * Gets available exam types for upload based on permissions
 * For upload context (uses 'xray')
 */
export const getAvailableExamTypes = (
  permissions: IModulePermissionType[] = []
): Array<'xray' | 'ecg'> => {
  const types: Array<'xray' | 'ecg'> = []

  if (permissions.includes('cxray_analysis')) types.push('xray')
  if (permissions.includes('ecg_analysis')) types.push('ecg')

  return types
}
